// @flow

import React, { useState, useMemo, useCallback,useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { fromJS } from 'immutable';
import chunk from 'lodash/chunk';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import colors from 'styles/colors';

import Pagination from 'react-js-pagination';

import SelectField from 'components/SelectField';
import DashboardDataTable from 'components/DashboardDataTableMaintenance';

import {
    HeaderText,
    SelectContainer,
    TableWrapper,
    Table,
    Button,
} from './styles';


const SELECT_VALUES = [10, 20, 30, 40, 50];

const ReportDataTable = (props) => {
    const {
        title,
        tableData: initialTableData,
        columns,
        reportFilterText,
        intl,
        vehicleId,
    } = props;

    const [itemsDisplayed, setItemsDisplayed] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [tableData, setTableData] = useState(initialTableData);
    const [sortKey, setSortKey] = useState('');
    useEffect(() => {
        setTableData(initialTableData);
    }, [initialTableData]);
    const selectOptions = useMemo(
        () =>
            SELECT_VALUES.map((value) => ({
                label: intl
                    .formatMessage({ id: 'containers.Reports.Generators.Driving.ShowResults' })
                    .replace('$value', value),
                value,
            })),
        [intl]
    );

    const handleOnChangeSelect = (value) => {
        setItemsDisplayed(value);
        setCurrentPage(1);
    };

    const handleOnChangePage = (value) => {
        setCurrentPage(value);
    };

    const getDefaultSort = useCallback((previousKey, key) => {
        const ascSort = (a, b) => {
            if (a.get(key) < b.get(key)) return -1;
            if (a.get(key) > b.get(key)) return 1;
            return 0;
        };

        const descSort = (a, b) => {
            if (a.get(key) < b.get(key)) return 1;
            if (a.get(key) > b.get(key)) return -1;
            return 0;
        };

        return previousKey === key ? descSort : ascSort;
    }, []);

    const handleOnClickHeaderItem = (key, sortMethod = null) => {
        if (!tableData) return;

        const defaultSort = getDefaultSort(sortKey, key);
        const sort = sortMethod || defaultSort;

        const sortedData = tableData.sort(sort);
        setTableData(sortedData);
        setSortKey(sortKey === key ? '' : key);
        setCurrentPage(1);
    };

    const getTableData = useCallback(
        () => {
            if (!tableData || !tableData.size) return null;
             
            const chunked = chunk(tableData.toArray(), itemsDisplayed);
            return fromJS(chunked[currentPage - 1]);
        },
        [tableData, itemsDisplayed, currentPage]
    );

    const renderPageButtons = () => {
        if (!tableData || !tableData.size) return null;

        return (
            <Button.Container>
                <Pagination
                    onChange={handleOnChangePage}
                    activePage={currentPage}
                    itemsCountPerPage={itemsDisplayed}
                    totalItemsCount={tableData.size}
                    pageRangeDisplayed={5}
                />
            </Button.Container>
        );
    };

    const data = getTableData();
    let totalPrice = 0;
    tableData &&
        tableData.forEach((item) => {
            if (item.get('Cout')) {
                totalPrice += parseFloat(item.get('Cout'));
            }
        });
    return (
    <div>
        <HeaderText>{title}</HeaderText>
        <SelectContainer>
            <SelectField
                options={selectOptions}
                value={itemsDisplayed}
                maxWidth={200}
                textColor={colors.black}
                onChange={handleOnChangeSelect}
            />
        </SelectContainer>
        <TableWrapper>
            <Table>
                <DashboardDataTable
                    vehicleId={vehicleId}
                    vehiculeNumb={title}
                    columns={columns}
                    tableData={data}
                    totalItemsCount={tableData.size}
                    totalPrice={totalPrice}
                    itemsDisplayed={itemsDisplayed}
                    showHeaderCaret={false}
                    onClickHeaderItem={handleOnClickHeaderItem}
                    reportFilterText={reportFilterText}
                    report
                />
            </Table>
        </TableWrapper>
        {tableData && tableData.size > 10 && renderPageButtons()}
    </div>);
};

const mapStateToProps = createStructuredSelector({
});

export default withRouter(connect(mapStateToProps)(injectIntl(ReportDataTable)));
